import { TimeSettingsCustomTimeRangeCategory } from 'generated/resources/graphql'

import { useForm } from 'modules/core/hooks/useForm'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useUpdateCustomTimeRangeCategory } from 'modules/time_categories_settings/hooks/useUpdateCustomTimeRangeCategory'

interface Props {
  category: TimeSettingsCustomTimeRangeCategory
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const EditCustomTimeRangeCategoriesForm = ({ setModalOpen, category }: Props) => {
  const { update } = useUpdateCustomTimeRangeCategory()
  const initialData = {
    ...category,
    name: category.name,
    archived: category.archived,
  }

  const form = useForm({
    defaultValues: initialData,
    enableReinitialize: true,
    onSubmit: async (data, { setErrors }) => {
      const payload = {
        ...data,
        name: data.name,
        archived: data.archived,
      }
      const result = await update(payload)
      const handled = handleResult(result, setErrors)
      if (handled.success) {
        setModalOpen(false)
        app.setFlash({
          type: 'correct',
          message: i18n.t('common.saved_successfully'),
        })
        form.resetForm()
      } else {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('time_tracking.settings.time_blocks.categories.modals.name_error'),
        })
      }

      return handled
    },
  })

  return form
}

export default EditCustomTimeRangeCategoriesForm
